import React, { Component } from 'react'
import './ModalTestimonials.scss'

const TESTIMONIALS = [{
    testimonial: "“Imagine a nossa felicidade em ganhar produtividade, se adaptar ao mercado e às tendências. Não tem jeito, quem não faz isso perde grandes oportunidades”",
    author: "Alexandre Santos",
    company: "Delícia Lanches",
},{
    testimonial: "“Tínhamos o desafio de dobrar o faturamento em 12 meses e conseguimos atingir essa meta em apenas 10. O software da Mercos foi crucial para isto.”",
    author: "Rafael A. Krause",
    company: "Grupo Herbia",
},{
    testimonial: "“Meu Foco é ajudar clientes a fazer negócios, para isso uso tanto o presencial quanto a tecnologia como aliados”",
    author: "Felipe Rodrigues",
    company: "IF Consultoria e Representação",
},{
    testimonial: "“Essencial para qualquer representante que quer crescer. Toda minha equipe usa Mercos, melhoramos o atendimento e aumentarmos nosso volume de vendas.”",
    author: "Afonso Tonelli",
    company: "Musical Plus Representações",
},
];
const TESTIMONIALS2 = [ {
    testimonial: "“Desconheço software de vendas igual. Com Mercos elevamos o faturamento em mais 300% em menos de 3 anos.”",
    author: "Gustavo Ribeiro",
    company: "Impacttus Cosméticos",
},{
    testimonial: "“Passamos a prospectar e vender, além do presencial, 24 horas e 7 dias da semana para os clientes! Nosso intuito era vender além do território que atingíamos com as vendas externas. E foi isso que começamos a fazer, em pouquíssimo tempo!”",
    author: "Alan Alves",
    company: "Almmati",
},{
    testimonial: "“Minha melhor experiência com a Mercos, é a facilidade que ele me dá na rua. A dinâmica que eu tenho e o volume de informações que eu consigo, isso me facilita muito!”",
    author: "Cristiano Oliveira",
    company: "Representante Comercial Harman",
}
];

class ModalTestimonials extends Component {
    render() {
        return (
            <div className="modal-testimonials">

                <div className="testimonials-col">
                    {
                        TESTIMONIALS.map((testimonial) => (

                            <div className="modal-testimonial-box">
                                <p className="modal-testimonial-text">{testimonial.testimonial}</p>
                                <p className="modal-testimonial-name">{testimonial.author}</p>
                                <p className="modal-testimonial-company">{testimonial.company}</p>
                            </div>
                        ))
                    }
                </div>
                <div className="testimonials-col testimonials-col2">
                    {
                        TESTIMONIALS2.map((testimonial) => (

                            <div className="modal-testimonial-box">
                                <p className="modal-testimonial-text">{testimonial.testimonial}</p>
                                <p className="modal-testimonial-name">{testimonial.author}</p>
                                <p className="modal-testimonial-company">{testimonial.company}</p>
                            </div>
                        ))
                    }
                </div>

            </div>
        )
    }

}
export default ModalTestimonials



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/TestimonialCard/ModalTestimonials.jsx